import React            from 'react';
import { useSelector }  from 'react-redux';
import moment           from 'moment';



const ProceedingInfo = () => {

    // Tomo el store
    const audience = useSelector(state => state.audiences.audienceWork);

    // Renderizo
    return (
        <div className="col-12">
            <div className="card shadow mb-4">
                <div className="card-header py-2 d-flex flex-row align-items-center justify-content-between">
                    <h6 className="m-0 font-weight-bold text-primary">DATOS LEGAJO</h6>
                </div>
                <div className="card-body">
                    {   audience 
                            ?
                                <div className="h6 mb-0 font-weight-bold text-gray-800">
                                    <div className="row">
                                        <div className="col-md-2 mb-1">
                                            <small>FECHA HECHO:</small>
                                            <br/>
                                            {   audience.expediente && audience.expediente.fechaHecho ? 
                                                    moment(audience.expediente.fechaHecho).format('DD/MM/YYYY')
                                                    : ''
                                            }
                                        </div>
                                        <div className="col-md-4 mb-1">
                                            <small>No. LEGAJO:</small>
                                            <br/>
                                            { audience.expediente && audience.expediente.numero }
                                        </div>
                                        <div className="col-12 mb-1">
                                            <small>CARÁTULA:</small>
                                            <br/>
                                            { audience.expediente && audience.expediente.caratula }
                                        </div>
                                    </div>
                                </div>
                            : 
                                null
                    }
                </div>
            </div>
        </div>
    );
};

export default ProceedingInfo;